import axios from 'axios';


axios.defaults.timeout = 50000;
axios.defaults.baseURL = process && process.env && process.env.NODE_ENV === 'development' ? 'http://10.173.0.17:3000' : 'https://spinxgames.com';
export default axios;



// WEBPACK FOOTER //
// ./src/http.js